var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _c("vue-event-calendar", {
          attrs: { events: _vm.events },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (props) {
                return _vm._l(props.showEvents, function (event, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "event-item" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "slide-fade" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "4" } }, [
                                _c("div", { staticClass: "calendar-date" }, [
                                  _c("div", { staticClass: "month" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.eventdateDOW) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "day" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.eventdateDay) +
                                        " " +
                                        _vm._s(_vm.eventdateMonth) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "8" } }, [
                                _c("div", { staticClass: "event-details" }, [
                                  _c(
                                    "h3",
                                    [
                                      _c(
                                        "generic-link",
                                        { attrs: { href: event.path } },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(event.title) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "location" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(event.desc) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }